<template>
  <div>
    <p>@Copyright 2023</p>
  </div>
</template>

<script>
export default {
  name: 'footer'
}
</script>

<style scoped>
p{
  font-size: 16px;
  text-align: left;
  text-indent: 16em;
}
</style>



// WEBPACK FOOTER //
// src/components2/Footer.vue